



















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    name: "SensorPanelContainer",
    props: {
        value: { type: Number, default: -1 },
        lastHeard: { type: String, default: "" },
    },
    setup(props, { emit }) {
        const panelValue = computed({
            get: () => props.value,
            set: (next: number) => emit("input", next),
        });

        return {
            panelValue,
        };
    },
});
